export interface BroadcastAudienceUserType {
  name: string;
  displayName: string;
}

/** user_types.name values — must match comm-center usersByRoles() resolution */
const ALL_USER_TYPES: BroadcastAudienceUserType[] = [
  { name: 'SYSTEM', displayName: 'System' },
  { name: 'ISO', displayName: 'ISO' },
  { name: 'SUB_ISO', displayName: 'Sub ISO' },
  { name: 'MERCHANT', displayName: 'Merchant' },
  { name: 'STORE_MANAGER', displayName: 'Store Manager' },
  { name: 'MULTI_STORE_MANAGER', displayName: 'Multi Store Manager' },
  { name: 'FINANCE_ADMIN', displayName: 'Finance Admin' }
];

const ISO_SCOPED: BroadcastAudienceUserType[] = ALL_USER_TYPES.filter(
  (t) => !['SYSTEM', 'FINANCE_ADMIN'].includes(t.name)
);

const SUB_ISO_SCOPED: BroadcastAudienceUserType[] = ALL_USER_TYPES.filter(
  (t) => !['SYSTEM', 'ISO', 'FINANCE_ADMIN'].includes(t.name)
);

const MERCHANT_SCOPED: BroadcastAudienceUserType[] = ALL_USER_TYPES.filter(
  (t) => ['MERCHANT', 'STORE_MANAGER', 'MULTI_STORE_MANAGER'].includes(t.name)
);

/** Scoped role options for broadcast audience — mirrors user-management setUserType scoping */
export function getBroadcastAudienceUserTypes(actorUserType: string): BroadcastAudienceUserType[] {
  switch (actorUserType) {
  case 'SYSTEM':
    return ALL_USER_TYPES;
  case 'ISO':
    return ISO_SCOPED;
  case 'SUB_ISO':
    return SUB_ISO_SCOPED;
  case 'MERCHANT':
    return MERCHANT_SCOPED;
  case 'STORE_MANAGER':
    return ALL_USER_TYPES.filter((t) => t.name === 'STORE_MANAGER');
  case 'MULTI_STORE_MANAGER':
    return ALL_USER_TYPES.filter((t) => t.name === 'MULTI_STORE_MANAGER');
  default:
    return [];
  }
}
